var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "XlsxFile",

    getDefaultProps () {
        return {"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"],[null,\"style\",\"enable-background:new 0 0 548.29 548.291;\"],[\"http://www.w3.org/2000/svg\",\"space\",\"preserve\"]]","x":"0px","y":"0px","width":"548.29px","height":"548.291px","viewBox":"0 0 548.29 548.291"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <g>
    <g>
      <path d="M472.929,131.399c-0.031-2.518-0.823-5-2.55-6.961L364.655,3.677c-0.021-0.031-0.052-0.042-0.083-0.073
			c-0.631-0.707-1.355-1.287-2.132-1.795c-0.231-0.152-0.462-0.286-0.704-0.421c-0.683-0.365-1.386-0.666-2.121-0.887
			c-0.198-0.06-0.377-0.139-0.577-0.194C358.23,0.121,357.41,0,356.571,0H96.757C84.904,0,75.255,9.651,75.255,21.502V526.79
			c0,11.858,9.649,21.501,21.502,21.501h354.776c11.862,0,21.502-9.643,21.502-21.501V132.6
			C473.035,132.199,472.973,131.795,472.929,131.399z M165.545,508.217l-9.352-18.703c-3.83-7.209-6.278-12.574-9.192-18.547h-0.307
			c-2.145,5.973-4.749,11.338-7.966,18.547l-8.585,18.703h-26.662l29.888-52.273l-28.812-51.029h26.822l9.042,18.861
			c3.063,6.276,5.364,11.327,7.821,17.155h0.3c2.457-6.594,4.446-11.188,7.047-17.155l8.741-18.861h26.662l-29.118,50.414
			l30.657,52.889H165.545z M269.591,508.217h-64.526V404.915h23.452v83.67h41.074V508.217z M308.66,509.739
			c-11.795,0-23.439-3.064-29.263-6.282l4.743-19.308c6.287,3.212,15.947,6.43,25.899,6.43c10.735,0,16.399-4.436,16.399-11.192
			c0-6.425-4.903-10.109-17.316-14.551c-17.161-5.973-28.354-15.475-28.354-30.498c0-17.623,14.709-31.108,39.087-31.108
			c11.639,0,20.232,2.446,26.353,5.212l-5.207,18.852c-4.142-1.99-11.496-4.908-21.613-4.908c-10.115,0-15.013,4.594-15.013,9.969
			c0,6.587,5.822,9.5,19.155,14.551c18.237,6.752,26.814,16.246,26.814,30.805C350.346,495.03,337.012,509.739,308.66,509.739z
			 M420.53,508.217l-9.354-18.703c-3.833-7.209-6.279-12.574-9.198-18.547h-0.294c-2.142,5.973-4.755,11.338-7.975,18.547
			l-8.583,18.703h-26.665l29.885-52.273l-28.814-51.029h26.823l9.051,18.861c3.061,6.276,5.354,11.327,7.806,17.155h0.31
			c2.446-6.594,4.44-11.188,7.05-17.155l8.736-18.861h26.666l-29.117,50.414l30.65,52.889H420.53z M96.757,365.085V21.507H345.82
			v110.015c0,5.935,4.809,10.75,10.751,10.75h94.962l0.01,222.813H96.757z"/>
      <path d="M310.933,138.004h-83.765h-94.516v40.316v5.375v34.94v5.375v34.939v5.375v40.319h89.141h5.375h83.765h5.376h89.14v-45.694
			v-34.939v-40.315v-5.375v-40.316H310.933z M310.933,218.636h-83.765v-34.94h83.765V218.636z M138.028,143.38h83.765v34.94h-83.765
			V143.38z M138.028,183.696h83.765v34.94h-83.765V183.696z M138.028,224.011h83.765v34.939h-83.765V224.011z M138.028,299.269
			v-34.943h83.765v34.943H138.028z M227.168,299.269v-34.943h83.765v34.943H227.168z M400.078,299.269h-83.77v-34.943h83.764v34.943
			H400.078z M400.078,218.636h-83.77v-34.94h83.764v34.94H400.078z M316.309,178.32v-34.94h83.764v34.94H316.309z"/>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/images/icons/xlsx-file.svg